import { render } from "./StudioView.vue?vue&type=template&id=0f595a2c"
import script from "./StudioView.vue?vue&type=script&lang=js"
export * from "./StudioView.vue?vue&type=script&lang=js"

import "./StudioView.vue?vue&type=style&index=0&id=0f595a2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__